import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  createFuelType,
  getFuelType,
  getFuelTypes,
  editFuelType,
  deleteFuelType,
} from "api/fuelTypeApi"

export const FUELTYPE_QUERY_KEY = "fuelTypes"

export const useFuelTypes = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: [FUELTYPE_QUERY_KEY, params],
    queryFn: () => getFuelTypes(params),
    keepPreviousData: true,
    enabled
  })
}

export const useFuelType = id => {
  return useQuery({
    queryKey: [FUELTYPE_QUERY_KEY, id],
    queryFn: () => getFuelType(id),
    enabled: !!id,
  })
}

export const useCreateFuelType = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createFuelType,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([FUELTYPE_QUERY_KEY])
      }
    },
  })
}

export const useEditFuelType = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: editFuelType,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([FUELTYPE_QUERY_KEY])
      }
    },
  })
}

export const useDeleteFuelType = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteFuelType,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([FUELTYPE_QUERY_KEY])
      }
    },
  })
}
